import type { Movie } from "@/types/movie";
import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/feature/SectionHeading";

interface RelatedMoviesProps {
  movies: Movie[];
  genre: string;
}

export default function RelatedMovies({ movies, genre }: RelatedMoviesProps) {
  if (!movies.length) return null;

  return (
    <section className="mt-10">
      <SectionHeading
        eyebrow="You may also like"
        title="同类型影片推荐"
        description={`根据「${genre}」类型为你匹配的影片，口味相近，接着看下去。`}
        actionLabel={`更多${genre}片`}
        actionTo={`/category/${encodeURIComponent(genre)}`}
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 lg:grid-cols-5">
        {movies.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}